<template>
    <div>
        <div class="panel-group accordion" id="sol-accordion" role="tablist" aria-multiselectable="false">
            <div class="panel panel-default" v-for="area in solutionsAreas" :key="area.id">
                <div class="panel-heading" role="tab" :id="'heading'+area.id">
                    <h4 class="panel-title">
                        <span 
                            tabindex="0" 
                            :class="isExpanded(area) ? '' : 'collapsed'"
                            data-toggle="collapse" 
                            data-parent="#sol-accordion" 
                            :data-target="'#collapse'+area.id" 
                            aria-expanded="false" 
                            :aria-controls="'collapse'+area.id">
                            <img :src="'/layouts/main/styles/images/'+area.icon+'.svg'" width="21" :title="area.name" /> {{area.name}}
                        </span>
                    </h4>
                </div>
                <div :id="'collapse'+area.id" class="panel-collapse collapse" :class="isExpanded(area) ? 'in' : ''" role="tabpanel" :aria-labelledby="'heading'+area.id">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-md-6" v-for="solution in area.solutions" :key="solution.SOLUTIONID">
                                <div class="radio">
                                    <label :for="'solution'+area.id+solution.SOLUTIONID">
                                        <input 
                                            type="radio" 
                                            name="solution" 
                                            :checked="isChecked(solution)" 
                                            :id="'solution'+area.id+solution.SOLUTIONID" 
                                            :value="(storename) ? solution.SOLUTION_TITLE : solution.SOLUTIONID"
                                            @change="emit('solution-selected',solution)" /> {{solution.SOLUTION_TITLE}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- For validation library -->
        <input type="hidden" name="fake-solution" id="fake-solution" :value="(solutionid == 0) ? '' : solutionid" :data-validate="validation" />
        <label class="errorMsg">{{errorMessage}}</label>
    </div>
</template>
<script>
    import useSolutionSelector from '../composables/useSolutionSelector'

    /*
        Solution selector is embedded on existing forms that use a validation library. All props are for that validation to function properly
    */
    export default {
        name: "SolutionSelector",
        emits: ['solution-selected'],
        props: {
            solutionid: String,
            storename: Boolean,
            validation: String,
            errorMessage: String
        },
        setup (props,{emit}) {
            const { getAreaSolutions, solutionsAreas } = useSolutionSelector();
            const isChecked = (value) => {
                if(props.storename) {
                    return value.SOLUTION_TITLE == props.solutionid;
                } else {
                    return value.SOLUTIONID == props.solutionid;
                }
            }
            const isExpanded = (area) => {
                return area.solutions.findIndex((solution) => {
                    return solution.SOLUTIONID == props.solutionid
                }) >= 0;
            }
            getAreaSolutions();

            return {
                solutionsAreas,
                emit,
                isChecked,
                isExpanded
            }
        }
    }
</script>